export enum UserCohorts {
    SOCIAL_BROWSE = 'SOCIAL_BROWSE',
}
